

export default {
    path: 'conv',
    name: 'project-conv',
    props: true,
    component: () => import("@/components/temp/Temp"),
}